import { forwardRef, useImperativeHandle, useState } from 'react';
import { twJoin } from 'tailwind-merge';

export type AnimatedBackdropHandler = {
  startDismissAnimation(): void;
};

type BackdropProps = {
  className: string;
  onDismissComplete(): void;
  variant: 'light' | 'strong';
};

export const AnimatedBackdrop = forwardRef<
  AnimatedBackdropHandler,
  BackdropProps
>(({ className, onDismissComplete, variant }, ref) => {
  const [fade, setFade] = useState<'in' | 'out'>('in');

  useImperativeHandle(ref, () => ({
    startDismissAnimation() {
      setFade('out');
    },
  }));

  const handleAnimationEnd = () => {
    if (fade === 'out') {
      onDismissComplete?.();
    }
  };

  return (
    <div
      aria-hidden="true"
      className={twJoin(
        className,
        'h-full w-full',
        variant === 'light' && 'bg-foundation-overlayLight',
        variant === 'strong' && 'bg-foundation-overlayLight',
        fade === 'in' && 'animate-fade-in',
        fade === 'out' && 'animate-fade-out',
      )}
      data-testid="animated-backdrop"
      onAnimationEnd={handleAnimationEnd}
      role="presentation"
    />
  );
});

AnimatedBackdrop.displayName = 'AnimatedBackdrop';
